"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AI_PROMPTS = void 0;
exports.AI_PROMPTS = {
    JD_GENERATION: {
        SYSTEM: `You are a professional Job Description writer. Create compelling, accurate, and inclusive job descriptions based on structured hiring criteria.

Use clear, professional language. Avoid jargon and bias. Focus on what candidates will do and achieve.`,
        USER_TEMPLATE: `Generate a professional Job Description based on the following criteria:

Company: {{companyName}}
Industry: {{industry}}
Company Size: {{companySize}}

Role: {{roleTitle}}
Years of Experience: {{yearsOfExperience}}
Work Type: {{workType}}
Location: {{location}}

Responsibilities:
{{responsibilities}}

Must-have Skills:
{{mustHaveSkills}}

Nice-to-have Skills:
{{niceToHaveSkills}}

Salary Range: {{salaryRange}}
Reporting To: {{reportingTo}}
Team Size: {{teamSize}}

Team Culture:
{{teamCulture}}

Success Metrics:
{{successMetrics}}

{{#if companyProfile}}
Company Profile:
{{companyProfile}}
{{/if}}

{{#if additionalInstructions}}
Additional Instructions:
{{additionalInstructions}}
{{/if}}

Generate a complete Job Description with the following sections:
1. Job Title
2. About the Company (2-3 sentences)
3. About the Role (2-3 sentences)
4. Key Responsibilities (bullet points)
5. Requirements - Must Have (bullet points)
6. Requirements - Nice to Have (bullet points)
7. What We Offer (bullet points)
8. Location & Work Arrangement`
    },
    FEEDBACK_SUMMARY: {
        SYSTEM: `You are an assistant that summarizes hiring manager feedback on job descriptions. Extract key points, identify action items, and assess overall sentiment.`,
        USER_TEMPLATE: `Summarize the following feedback from a Hiring Manager on a Job Description:

Job Description Title: {{jdTitle}}
Feedback Source: {{feedbackSource}}
Feedback Date: {{feedbackDate}}

Raw Feedback:
{{rawFeedback}}

Respond in JSON format:
{
  "summary": "Brief summary of the feedback",
  "keyPoints": ["point1", "point2"],
  "actionItems": [
    {"description": "action to take", "priority": "high|medium|low"}
  ],
  "sentiment": "positive|neutral|negative|mixed"
}`
    },
    // ===== MODULE PROMPTS =====
    COMPANY_RESEARCH: {
        //     SYSTEM: `You are a senior business intelligence researcher specializing in corporate due diligence for executive search firms. Your role is to produce comprehensive company dossiers that help Talent Acquisition professionals deeply understand companies.
        // You MUST provide thorough, actionable insights. Where information is uncertain, note it as "unverified" rather than omitting it. Structure your output as a clear, well-organized research report with proper headings and sections.`,
        DEEP_RESEARCH_TEMPLATE: `Please help me to do a comprehensive research about {{companyName}}, which includes details about their local business/operations and regional/international footprints (if any), details of their organisation, team structure and key decision makers, breakdown of their financials and business models, competitors and competitive landscape as well as company directions and/or latest development that they have highlighted or shared publicly, if any.

Please also provide an Executive Summary that synthesises key findings from the above research areas into a concise high-level overview of the company.

Company Website: {{website}}
Company LinkedIn: {{linkedinUrl}}

{{additionalContext}}`,
        JSON_EXTRACTION_SYSTEM: `You are a data extraction specialist. Extract structured company intelligence data from research reports and return it as clean JSON. Be thorough — extract every piece of information available in the report. Always respond in valid JSON format only.`,
        JSON_EXTRACTION_TEMPLATE: `Extract structured data from the following company research report into the JSON format specified below. Extract ALL available information from the report. Use null for fields where information is not mentioned.

Company Research Report:
{{researchContent}}

Return the extracted data in this JSON format:
{
  "executiveSummary": "A concise executive summary that synthesises key findings from the research — covering the company's local business/operations, regional/international footprint, organisation and key decision makers, financials and business models, competitive landscape, and latest company directions.",
  "overview": {
    "history": "Detailed company history including founding story",
    "mission": "Company mission and vision",
    "productsServices": ["product1", "service1"],
    "headquarters": "Location",
    "founded": "Year",
    "size": "Employee count or range"
  },
  "corporateStructure": {
    "parentCompany": "Parent company name or null",
    "groupAffiliation": "Description of group/conglomerate relationship",
    "subsidiaries": [
      {"name": "Subsidiary name", "country": "Country", "focus": "Business focus"}
    ],
    "jointVentures": ["JV description"],
    "ownershipType": "public|private|state-owned|family-owned"
  },
  "regionalFootprint": {
    "countriesOfOperation": ["Country1", "Country2"],
    "keyMarkets": ["Market1", "Market2"],
    "expansionHistory": "Description of geographic expansion over time",
    "regionalHQs": [
      {"region": "Region name", "location": "City, Country"}
    ]
  },
  "facilitiesAndOffices": [
    {"type": "headquarters|plant|office|r_and_d|distribution", "location": "City, Country", "description": "Details about the facility"}
  ],
  "leadership": [
    {"name": "Name", "title": "Title", "background": "Career history and tenure", "decisionScope": "What they oversee"}
  ],
  "financials": {
    "status": "public|private|startup",
    "revenue": "Latest revenue figure or range",
    "profitability": "Description",
    "marketCap": "If public",
    "recentFunding": "If applicable",
    "growthTrajectory": "Description of financial trajectory",
    "healthIndicators": "Overall financial health assessment"
  },
  "strategicDirection": {
    "announcedPlans": ["Plan1", "Plan2"],
    "growthStrategy": "Description",
    "mergersAndAcquisitions": ["Recent or planned M&A activity"],
    "partnerships": ["Key partnerships"],
    "digitalTransformation": "Description if relevant",
    "newMarketEntries": ["New markets or product lines"]
  },
  "marketPosition": {
    "competitors": ["competitor1", "competitor2"],
    "marketShare": "Description",
    "uniqueSellingPoints": ["point1", "point2"],
    "competitiveAdvantages": ["advantage1"],
    "vulnerabilities": ["vulnerability1"]
  },
  "culture": {
    "values": ["value1", "value2"],
    "workEnvironment": "Description",
    "employeeSentiment": "positive|neutral|negative|mixed",
    "deiInitiatives": "Description",
    "notableAwards": ["Award1"]
  },
  "recentNews": [
    {"headline": "News headline", "date": "Date", "summary": "Brief summary", "significance": "high|medium|low"}
  ],
  "employeeInsights": {
    "workforceSize": "Number or range",
    "growthAreas": ["area1", "area2"],
    "hiringChallenges": ["challenge1"],
    "talentStrategy": "How the company attracts/retains talent"
  },
  "industryContext": {
    "industryTrends": ["trend1", "trend2"],
    "regulatoryEnvironment": "Description",
    "technologyShifts": "Description",
    "outlookForCompany": "How industry trends affect this specific company"
  }
}`
    },
    DEAL_BRIEFING: {
        SYSTEM: `You are a Deal Info Curation Analyst for Canis Major Group (CMG). Your role is to process raw intake meeting notes, analyze team/stakeholder context using company research data, and draft measurable KPIs — all consolidated into a single, unified Deal Briefing document.

The CMG Deal Briefing has 4 mandatory sections. You MUST follow the exact formatting conventions shown below:

## Section 1: Meeting Notes with [Client Contact Name] ([Title])

The section title must include the primary client contact's name and title extracted from the notes.

Sub-sections (all 4 required):

a) Top/High Priority Search Criteria & Scope:
   Each item is a bold topic label followed by a colon and detailed description.
   Example format:
     **Scale & Complexity:** The candidate must have experience managing large workforces (4,000+ employees) spread across multiple blue-collar industrial/production sites.
     **Industrial Relations (IR) & Compliance:** Heavy emphasis on an "encyclopedic knowledge" of local labor laws...

b) Experience Level & Team Structure:
   Written as clear descriptive statements about seniority, years, reporting line, and team structure.
   Example format:
     Executive Level (15+ years experience required).
     Will report to and act as a trusted advisor to the Board of Directors.

c) Culture Fit & Work Approach:
   Written as clear descriptive statements about behavioral expectations, work style, and operational philosophy.
   Example format:
     Requires "Operational Grit"—must be willing to travel to and interface with remote production sites (farms, feedmills) across the country, not just sit in the head office.
     Needs a sharp business mind, operating as a commercial enabler rather than an administrative roadblock.

d) Compensation & Benefits:
   Budget/range details. The "Salary Range (Net)" field provided in the input is the NET salary (take-home pay) — you MUST use this directly as the Budget when it is provided (i.e. not "Competitive" or empty). Format it as "[currency] [min] - [max] net per month" using the min/max/currency values from the salaryRange field. Only mark as TBD if the salary range is genuinely not provided.
   Example format:
     **Budget:** [currency] [min] - [max] net per month (based on provided net salary range). OR if truly not provided: Not yet provided/TBD. We will need to benchmark and present highly qualified candidates to help the client calibrate the market rate for this seniority level.

## Section 2: Current Team Assessment (CTA)

Sub-sections (all required):

a) Key Stakeholders & Team Structure Overview:
   Start with structural info if available (Reporting Line, Key Interviewers, Direct Reports, Key Internal Collaborators).
   Then for each known stakeholder, provide their name (title) followed by a colon, then a narrative paragraph about who they are, their background, role in the hiring process, and relevance.
   When enough data is available for a stakeholder, include an "Inference for Candidate:" sub-point that translates the stakeholder context into what it means for the ideal candidate.
   
   Example format (Style A - traditional):
     **Lau Joo Hwa (Director):** Our primary point of contact for this search. He represents the younger generation of the founding Lau family, bringing modern perspectives to operations...
   
   Example format (Style B - structured):
     Reporting Line: Reports directly to the Group CEO, Singapore (Ong Yuh Hwang).
     Key Interviewers: Ong Yuh Hwang (Group CEO), Group Director HR, Group Director Sales, Chairman (Optional).
     Direct Reports: 5 Heads (Finance, Logistics, Marketing, Sales).
     **Ong Yuh Hwang (Group CEO):** The key driver of this search...
     Inference for Candidate: The ideal Country GM is being hired to be the expert commercial executor...

b) Analysis of Stakeholder Environment:
   Insightful paragraphs about how the team dynamics, business context, corporate governance, and organizational culture affect the hiring decision.
   Each paragraph should be a self-contained analytical insight.

## Section 3: Sample Key Performance Indicators (KPIs) for Discussion

Include a note with the status (client-provided or drafted for discussion).

KPIs are organized by category. Each category has a bold category name followed by individual KPI statements as self-contained descriptive sentences.

If the client explicitly provided KPIs, format them cleanly. If NOT provided, you MUST proactively draft highly relevant, measurable sample KPIs based on the role context.

Example format:
  **Industrial Relations & Risk Mitigation:**
  Zero critical operational disruptions or strikes across all national production facilities due to labor disputes.
  Maintain 100% compliance with BPJS, Depnaker regulations, and local labor laws, with zero major audit findings or penalties.

  **HR Digitalization & Operational Efficiency:**
  Successful implementation and 100% adoption rate of the new/upgraded HRIS platform across all national sites within a specified timeframe (e.g., 12-18 months).

## Section 4: Key Hiring Information

This is the structured candidate profile requirements document. It MUST contain an Overall Role Mandate and exactly 6 sub-sections labeled A through F. Every item must be tagged with a priority from the Priority Legend.

Priority Legend: (MH) = Must-Have; (SP) = Strongly Preferred; (NTH) = Nice-to-Have

The header must include the client name, job title, and deal code.

Sub-sections (all 6 MANDATORY — always labeled A through F):

A. Experience:
   - Industry Experience: Senior leadership role context with priority tag.
   - Functional Expertise: Multiple line items, each describing a specific functional capability with a priority tag.
   Example format:
     Industry Experience: Senior leadership role in FMCG or F&B (MH)
     Functional Expertise:
       Deep, hands-on expertise in managing both General Trade (GT) and Modern Trade (MT) channels (MH - CRITICAL)
       Proven success managing a large, complex distributor network (MH - CRITICAL)
       Full P&L Management responsibility (GM, Country Mgr, Sales/Commercial Director level) (MH)

B. Hard Skills:
   Named skill categories, each with a description and priority tag.
   Example format:
     Commercial & Sales Strategy: Ability to develop and execute aggressive growth plans (MH)
     Distributor Management: Expertise in distributor performance metrics, incentives, and relationship mgt (MH)

C. Soft Skills:
   Named soft skill categories, each with a description and priority tag.
   Example format:
     Leadership: Exceptional leadership, ability to drive a sales culture (MH)
     Hands-on Problem Solving: Ability to fix operational issues directly (MH)
     Negotiation & Influence: Strong skills for managing distributors and internal stakeholders (SP)

D. Education & Qualifications:
   Degree requirements and professional certifications with priority tags.
   Example format:
     Degree: Bachelor's degree or higher (MH)

E. Personality & Cultural Fit:
   Key personality traits and cultural alignment requirements with priority tags.
   Example format:
     Key Traits: Sales-Driven, Commercial, Executor, Hands-on, Pragmatic, Results-Oriented (MH)
     Culture Alignment: Ability to implement CEO's vision, Navigate complex reporting structure (MH)

F. Other:
   Location, timeline, travel, language, and any other requirements with priority tags.
   Example format:
     Location: Based in the client's primary location (MH)
     Timeline: Able to start by April 1, 2026 (MH)

Key principles:
- Extract and structure raw notes into the above format. Enhance with analytical insight from company research.
- Be factual, research-driven, and specific. Avoid generic filler.
- Flag information gaps that the consultant should follow up on.
- Always respond in structured JSON format.`,
        USER_TEMPLATE: `Process the following raw intake information into a unified CMG Deal Briefing:

Deal Code: {{dealCode}}
Client: {{companyName}}
Industry: {{industry}}
Role/Position: {{roleTitle}}
Years of Experience: {{yearsOfExperience}}
Team/Department: {{department}}
Current Team Size: {{teamSize}}
Team Structure: {{teamStructure}}
Reporting To: {{reportingTo}}
Salary Range (Net): {{salaryRange}}

Raw Meeting Notes / Intake Information:
{{rawNotes}}

Company Research Data:
{{companyResearch}}

Additional Context:
{{additionalContext}}

Respond in JSON format:
{
  "dealBriefing": {
    "metadata": {
      "dealCode": "{{dealCode}}",
      "client": "{{companyName}}",
      "role": "{{roleTitle}}",
      "compiledBy": "Deal Info Curation Analyst"
    },
    "section1_meetingNotes": {
      "documentTitle": "Meeting Notes with [Client Contact Name] ([Title])",
      "topPriorityCriteriaAndScope": [
        {"topic": "Scale & Complexity", "detail": "The candidate must have experience managing large workforces (4,000+ employees) spread across multiple blue-collar industrial/production sites."},
        {"topic": "Industrial Relations (IR) & Compliance", "detail": "Heavy emphasis on an \\"encyclopedic knowledge\\" of local labor laws and ability to act as the primary liaison with government bodies. IR capability is non-negotiable to prevent disruptions at production sites."}
      ],
      "experienceLevelAndTeamStructure": [
        "Executive Level (15+ years experience required).",
        "Will report to and act as a trusted advisor to the Board of Directors."
      ],
      "cultureFitAndWorkApproach": [
        "Requires \\"Operational Grit\\"—must be willing to travel to and interface with remote production sites (farms, feedmills) across the country, not just sit in the head office.",
        "Needs a sharp business mind, operating as a commercial enabler rather than an administrative roadblock."
      ],
      "compensationAndBenefits": [
        {"topic": "Budget", "detail": "Not yet provided/TBD. We will need to benchmark and present highly qualified candidates to help the client calibrate the market rate for this seniority level."}
      ]
    },
    "section2_currentTeamAssessment": {
      "structuredOverview": {
        "reportingLine": "Reports directly to [Title], [Location] ([Name]). Omit if not known.",
        "keyInterviewers": "List of interviewers and stages. Omit if not known.",
        "directReports": "Number and types of direct reports. Omit if not known.",
        "keyInternalCollaborators": "Key internal partners. Omit if not known."
      },
      "keyStakeholders": [
        {
          "stakeholder": "Lau Joo Hwa (Director)",
          "description": "Our primary point of contact for this search. He represents the younger generation of the founding Lau family, bringing modern perspectives to operations. His involvement indicates a strong desire to modernize the company's human capital infrastructure.",
          "inferenceForCandidate": "Optional. Include only when there is enough data to draw a meaningful inference about what this stakeholder's profile means for the ideal candidate."
        }
      ],
      "analysisOfStakeholderEnvironment": [
        "The HCD will be stepping into a mature, family-founded conglomerate that is actively transitioning toward highly institutionalized, modern corporate governance (backed by Private Equity history and public market scrutiny).",
        "The candidate must be highly politically astute, able to respectfully advise seasoned industry veterans on the Board while driving necessary modernization and digital HR initiatives mandated by the younger directors."
      ]
    },
    "section3_kpis": {
      "status": "Client Provided | Drafted for Discussion",
      "categories": [
        {
          "categoryName": "Industrial Relations & Risk Mitigation",
          "kpis": [
            "Zero critical operational disruptions or strikes across all national production facilities due to labor disputes.",
            "Maintain 100% compliance with BPJS, Depnaker regulations, and local labor laws, with zero major audit findings or penalties."
          ]
        },
        {
          "categoryName": "HR Digitalization & Operational Efficiency",
          "kpis": [
            "Successful implementation and 100% adoption rate of the new/upgraded HRIS platform across all national sites within a specified timeframe (e.g., 12-18 months).",
            "Measurable reduction in HR administrative processing time (e.g., payroll processing, attendance tracking)."
          ]
        }
      ]
    },
    "section4_keyHiringInformation": {
      "header": {
        "clientName": "{{companyName}}",
        "jobTitle": "{{roleTitle}}",
        "dealCode": "{{dealCode}}"
      },
      "overallRoleMandate": "A concise statement summarizing the core mandate and strategic purpose of the role, derived from meeting notes and CTA context.",
      "priorityLegend": "(MH) = Must-Have; (SP) = Strongly Preferred; (NTH) = Nice-to-Have",
      "A_experience": {
        "industryExperience": {
          "requirement": "Senior leadership role in FMCG or F&B manufacturing/distribution, ideally with mass-market consumer goods.",
          "priority": "MH"
        },
        "functionalExpertise": [
          {
            "requirement": "Deep, hands-on expertise in managing both General Trade (GT) and Modern Trade (MT) channels.",
            "priority": "MH - CRITICAL"
          },
          {
            "requirement": "Proven success managing a large, complex distributor network (principal-distributor model) across multiple regions.",
            "priority": "MH - CRITICAL"
          },
          {
            "requirement": "Full P&L Management responsibility at GM, Country Manager, or Senior Sales/Commercial Director level.",
            "priority": "MH"
          }
        ]
      },
      "B_hardSkills": [
        {
          "skill": "Commercial & Sales Strategy",
          "detail": "Ability to develop and execute aggressive, market-specific growth plans for the local market.",
          "priority": "MH"
        },
        {
          "skill": "Distributor Management",
          "detail": "Expertise in distributor selection, performance metrics, incentive structures, and relationship management.",
          "priority": "MH"
        }
      ],
      "C_softSkills": [
        {
          "skill": "Leadership",
          "detail": "Exceptional leadership and team-building ability; can inspire, manage, and drive a sales culture across a geographically dispersed team.",
          "priority": "MH"
        },
        {
          "skill": "Hands-on Problem Solving",
          "detail": "Willingness and ability to get into the field, understand ground-level challenges, and fix operational issues directly.",
          "priority": "MH"
        },
        {
          "skill": "Negotiation & Influence",
          "detail": "Strong negotiation skills for managing distributor terms, key account negotiations, and internal stakeholder influence.",
          "priority": "SP"
        }
      ],
      "D_educationAndQualifications": [
        {
          "requirement": "Bachelor's degree or higher in Business, Marketing, or related field.",
          "priority": "MH"
        }
      ],
      "E_personalityAndCulturalFit": {
        "keyTraits": {
          "traits": "Sales-Driven, Commercial, Executor, Hands-on, Pragmatic, Results-Oriented, Resilient",
          "priority": "MH"
        },
        "cultureAlignment": {
          "requirement": "Ability to operate within and implement the Regional CEO's vision. Navigate complex reporting structure.",
          "priority": "MH"
        }
      },
      "F_other": [
        {
          "item": "Location",
          "detail": "Based in the client's primary location, with extensive regular travel to key distribution hubs and regions.",
          "priority": "MH"
        },
        {
          "item": "Timeline",
          "detail": "Able to start by April 1, 2026 (NTP Q1 2026).",
          "priority": "MH"
        }
      ]
    },
    "informationGaps": ["Topics not covered that the consultant should follow up on with the client"]
  }
}`,
        READABLE_SYSTEM: 'You are a professional executive search content writer for Canis Major Group (CMG). You convert structured Deal Briefing JSON into a polished, client-ready markdown document with exactly 4 sections.',
        READABLE_TEMPLATE: `Convert the following Deal Briefing JSON into a polished markdown document.

CRITICAL: The document MUST have this EXACT structure with EXACTLY 4 top-level sections (## headings). Do NOT add, rename, merge, or split sections:

**Header (no ## heading):**
# Executive Search Briefing: [Role Title]
**Client:** [Client Name]
**Deal Code:** [Deal Code]
**Compiled By:** Deal Info Curation Analyst

**## Section 1 — Meeting Notes with [Client Contact Name] ([Title])**
Format sub-sections as ### headings:
### Top/High Priority Search Criteria & Scope (bold topic labels with colon, then detail)
### Experience Level & Team Structure (descriptive statements)
### Culture Fit & Work Approach (descriptive statements)
### Compensation & Benefits (bold topic labels with detail)

**## Section 2 — Current Team Assessment (CTA)**
Format sub-sections as ### headings:
### Key Stakeholders & Team Structure Overview
  - Start with structural overview (Reporting Line, Key Interviewers, Direct Reports, Key Internal Collaborators) if available
  - Then each stakeholder: bold name (title) with narrative paragraph
  - Include "Inference for Candidate:" sub-points where present
### Analysis of Stakeholder Environment (analytical paragraphs)

**## Section 3 — Sample Key Performance Indicators (KPIs) for Discussion**
Include the status note. Then bold category names (###) with KPI bullet points under each.

**## Section 4 — Key Hiring Information**
Include header info (Client, Job Title, Deal Code), Overall Role Mandate, Priority Legend.
Then format sub-sections as ### headings:
### A. Experience (Industry Experience + Functional Expertise items with priority tags)
### B. Hard Skills (skill name: detail with priority tag)
### C. Soft Skills (skill name: detail with priority tag)
### D. Education & Qualifications (requirements with priority tags)
### E. Personality & Cultural Fit (Key Traits + Culture Alignment with priority tags)
### F. Other (item: detail with priority tags)

End with ## Information Gaps if present.

RULES:
- Use exactly 4 ## sections (Meeting Notes, CTA, KPIs, Key Hiring Information)
- Do NOT invent section names like "Executive Summary" or "Strategic Priorities"
- Do NOT merge or restructure sections
- Preserve all priority tags (MH), (SP), (NTH) exactly as given
- Do not include any JSON syntax in the output

JSON Data:
{{jsonContent}}`
    },
    STANDARD_JD: {
        SYSTEM: `You are a Deal Info Curation Analyst for CMG (Canis Major Group), an executive search firm. Your task is to create or enhance an Official Job Description (OJD) in CMG's standardized format.

The CMG OJD MUST contain a HEADER INFO section followed by 4 content sections, in this exact order:

HEADER INFO (metadata table):
- Client: Company name
- Role/Position: Job title
- Location: City/region
- Reports To: Direct reporting line
- Contract: Employment type (Permanent/Contract/Freelance/Internship)

CONTENT SECTIONS:
1. About the Role — paragraph describing the position scope, strategic importance, and core objective
2. About the Company — paragraph with company name, founding history, listing status, group affiliation, scale, and market position
3. Key Responsibilities — each with a bold category title followed by a description paragraph
4. Ideal Candidate / Qualifications — bullet points with **Bold Label:** format, covering education, must-have experience, strongly preferred, and nice-to-have qualifications

Key principles:
- If an original JD is provided by the client, restructure it into CMG's format while preserving core requirements
- If NO original JD exists, draft from scratch using meeting notes, company research, and role context
- Calibrate tone and language to the seniority level
- Do NOT include any draft notes, disclaimers, or meta-commentary in the output — only the JD content itself`,
        USER_TEMPLATE: `Create the Official Job Description (OJD) for this deal:

Deal Code: {{dealCode}}
Company: {{companyName}}
Industry: {{industry}}
Location: {{location}}

Role: {{roleTitle}}
Years of Experience: {{yearsOfExperience}}
Work Type: {{workType}}
Contract Type: {{contractType}}
Urgency Level: {{urgencyLevel}}
Salary Range: {{salaryRange}}
Reports To: {{reportingTo}}

About Company:
{{companyInfo}}

Responsibilities:
{{responsibilities}}

Must-Have Skills:
{{mustHaveSkills}}

Nice-to-Have Skills:
{{niceToHaveSkills}}

Team Info:
{{teamInfo}}

Benefits:
{{benefits}}

### Context from Other Modules (use to enrich the JD):

Company Research:
{{companyResearch}}

Meeting Notes:
{{meetingNotes}}

Team Assessment:
{{teamAssessment}}

Additional Context (may include raw/original JD from client):
{{additionalContext}}

IMPORTANT: If responsibilities or skills fields are empty, use meeting notes and company research to draft comprehensive content.

Respond in JSON format:
{
  "officialJD": {
    "metadata": {
      "dealCode": "string",
      "client": "Company name",
      "roleTitle": "Job title",
      "location": "City/region",
      "reportsTo": "Direct reporting line (e.g., VP of Technology). Infer from team assessment/meeting notes if not provided.",
      "contractType": "Permanent / Contract / Freelance / Internship",
      "contractType": "Permanent / Contract / Freelance / Internship"
    },
    "content": {
      "1_aboutTheRole": "Paragraph summarizing the position, its strategic importance, operational scope, and core objective.",
      "2_aboutTheCompany": "1-2 paragraphs with company name, founding history, listing status, group affiliation, scale of operations, and market position.",
      "3_keyResponsibilities": [
        {"title": "Category Title (e.g., Plant Operations Leadership)", "description": "Detailed description of what the candidate will do in this area."}
      ],
      "4_idealCandidateQualifications": [
        {
          "category": "Experience",
          "items": [
            "5-7+ years in [relevant role/domain]",
            "**Preferred:** Experience from [type of org, e.g. Big 4 Consultancies] or direct competitors in the [sector]",
            "Proven experience in [specific area relevant to role]"
          ]
        },
        {
          "category": "Technical & Functional Skills",
          "items": [
            "Deep understanding of [domain concepts and methodologies]",
            "**Mandatory exposure and proficiency:** [specific tools, technologies, platforms]",
            "Strong [technical skill] and experience with [related systems]"
          ]
        },
        {
          "category": "Soft Skills",
          "items": [
            "Excellent analytical, conceptual thinking, and problem-solving abilities",
            "Strong communication, presentation, and interpersonal skills"
          ]
        },
        {
          "category": "Education",
          "items": [
            "Bachelor's or Master's degree in [relevant field]"
          ]
        }
      ]
    }
  }
}`,
        READABLE_SYSTEM: `You are a professional HR document formatter. Convert structured JD JSON data into a clean, well-formatted markdown document following CMG's exact template. Do NOT add any content — only format what is provided.`,
        READABLE_TEMPLATE: `Convert the following Official JD JSON into CMG's standard markdown format. Output ONLY the formatted markdown, no explanations.

JSON Data:
{{jsonContent}}

Format the output in EXACTLY this markdown structure:

| | | |
|---|---|---|
| **Client** | : | **[client name]** |
| **Role / Position** | : | **[role title]** |
| **Location** | : | [location] |
| **Reports To** | : | [reports to] |
| **Contract** | : | [contract type] |

## About the Role
[aboutTheRole paragraph]

## About the Company
[aboutTheCompany paragraph]

## Key Responsibilities

- **[Category Title]** [Description paragraph]
- **[Category Title]** [Description paragraph]

## Ideal Candidate / Qualifications

- **Experience:**
  - [sub-bullet items]
- **Technical & Functional Skills:**
  - [sub-bullet items]
- **Soft Skills:**
  - [sub-bullet items]
- **Education:**
  - [sub-bullet items]

RULES:
- Use the EXACT markdown table format with "| Key | : | Value |" for the header info
- Only include header rows where data is available (not "Not specified")
- Each Key Responsibility must be a bullet point with bold title followed by description on the same line
- Ideal Candidate / Qualifications must use nested bullets: top-level bullet with bold category name followed by colon, then indented sub-bullets for each item
- Bold and emphasize key phrases within sub-bullets where appropriate (e.g. **Preferred:**, **Mandatory exposure and proficiency:**)
- Do NOT wrap in code fences
- Do NOT add any content not present in the JSON`
    },
    BLIND_JD: {
        SYSTEM: `You are a Deal Info Curation Analyst for CMG (Canis Major Group). Your task is to create a Blind Job Description for external sourcing and confidential outreach (stealth searches).

STRICT Anonymization rules — the recipient must NOT be able to reverse-engineer the client's identity:

1. **Company name**: Replace with a generic industry descriptor (e.g., "A leading Southeast Asian integrated poultry producer" instead of naming the company).
2. **Project & subsidiary names**: Remove all specific internal project names, subsidiary names, and brand names.
3. **Employee count / workforce size**: Replace exact numbers with qualitative descriptors (e.g., "10,000+ employees" → "large-scale workforce", "500 staff" → "sizeable team").
4. **Revenue / financial metrics**: Replace with qualitative terms (e.g., "$2B revenue" → "significant revenue", "IDR 15T turnover" → "multi-billion revenue").
5. **Production volume / operational scale**: Anonymize all volume metrics (e.g., "200,000 tons/year" → "high-volume production operations", "50 hectares" → "extensive operational footprint", "30 plants" → "multiple manufacturing facilities").
6. **Founding year / history duration**: Replace with era descriptors (e.g., "Founded in 1971" → "established for over five decades", "IPO in 2005" → "publicly listed").
7. **Number of countries / locations**: Generalize (e.g., "Operations in 12 countries" → "multinational presence across the region", "3 offices in Indonesia" → "multiple offices nationwide").
8. **Market share / ranking**: Anonymize (e.g., "#1 in Indonesia" → "market-leading position", "35% market share" → "dominant market share").
9. **Location specificity**: Generalize (e.g., "Sidoarjo, East Java" → "Indonesia", "Revenue Tower, SCBD" → "Jakarta").
10. **Reporting line**: Generalize the title (e.g., "Reports to VP of Technology, John Smith" → "Reports to a C-Suite / Senior Executive").

Preserve: the role's appeal, required skills, core responsibilities, and compensation range.`,
        USER_TEMPLATE: `Create a Blind JD based on this Official JD. Apply ALL anonymization rules strictly — no numbers, names, or specifics that could identify the client.

Client (TO HIDE): {{companyName}}
Role: {{roleTitle}}
Industry: {{industry}}
Location: {{location}}
Contract Type: {{contractType}}
Urgency Level: {{urgencyLevel}}
Compensation: {{salaryRange}}
Reports To (TO ANONYMIZE): {{reportingTo}}

Standard JD Content:
{{standardJD}}

Respond in JSON format:
{
  "blindJD": {
    "metadata": {
      "position": "Role title (keep as-is, not identifying)",
      "industry": "Generalized industry descriptor",
      "location": "Generalized location (country-level)",
      "contractType": "Permanent / Contract / etc.",
      "reportsTo": "Generalized title (e.g., C-Suite Executive, Senior Leadership)",
      "clientDescription": {
        "en": "ENGLISH: a concise, fully-anonymized noun phrase describing the client for confidential outreach — MUST grammatically complete 'Our client, ___, is seeking...'. Example: 'a well-capitalised fintech enterprise specialising in AI-driven Banking-as-a-Service'. No company name, numbers, or identifiable specifics. Lowercase start, no trailing period.",
        "id": "BAHASA INDONESIA (terjemahan natural dari versi en): frasa nomina ringkas dan teranonimisasi yang HARUS melengkapi kalimat 'Klien kami, ___, sedang mencari...'. Contoh: 'sebuah perusahaan fintech dengan permodalan kuat yang berfokus pada Banking-as-a-Service berbasis AI'. Tanpa nama, angka, atau detail yang dapat mengidentifikasi klien. Diawali huruf kecil, tanpa titik di akhir."
      },
      "rolePurpose": {
        "en": "ENGLISH: a concise verb phrase stating the single main purpose of the role — MUST grammatically complete 'is seeking a high-impact individual to ___'. Example: 'spearhead the ground-up establishment of their commercial operations in the region'. Lowercase start, no trailing period.",
        "id": "BAHASA INDONESIA (terjemahan natural dari versi en): frasa kerja ringkas yang menyatakan tujuan utama peran — HARUS melengkapi 'sedang mencari individu berdampak tinggi untuk ___'. Contoh: 'memimpin pembentukan operasi komersial mereka dari awal di kawasan ini'. Diawali huruf kecil, tanpa titik di akhir."
      }
    },
    "content": {
      "1_aboutTheRole": "Anonymized paragraph describing the role scope, key impact, and strategic importance.",
      "2_aboutOurClient": "Anonymized paragraph describing client's scale, market position, and industry WITHOUT any specific numbers, names, or identifiable metrics.",
      "3_keyResponsibilities": [
        {"title": "Category Title", "description": "Anonymized responsibility description — remove any company-specific project names or identifiable details."}
      ],
      "4_idealCandidateQualifications": [
        {
          "category": "Experience",
          "items": [
            "Years and type of experience required (anonymized)",
            "**Preferred:** Type of organizational background valued"
          ]
        },
        {
          "category": "Technical & Functional Skills",
          "items": [
            "Domain expertise requirements (generalized)",
            "**Mandatory exposure and proficiency:** Key tools and platforms"
          ]
        },
        {
          "category": "Soft Skills",
          "items": [
            "Leadership and interpersonal skill requirements"
          ]
        },
        {
          "category": "Education",
          "items": [
            "Qualification requirement"
          ]
        }
      ]
    },
    "anonymizedDetailsLog": ["List every specific term/number/name that was successfully anonymized and what it was replaced with"]
  }
}`,
        READABLE_SYSTEM: `You are a professional HR document formatter. Convert structured Blind JD JSON data into a clean, well-formatted markdown document. Do NOT add any content — only format what is provided.`,
        READABLE_TEMPLATE: `Convert the following Blind JD JSON into CMG's standard markdown format. Output ONLY the formatted markdown, no explanations.

JSON Data:
{{jsonContent}}

Format the output in EXACTLY this markdown structure:

| | | |
|---|---|---|
| **Industry** | : | **[generalized industry descriptor]** |
| **Role / Position** | : | **[position]** |
| **Location** | : | [location] |
| **Reports To** | : | [reportsTo] |
| **Contract** | : | [contractType] |

## About the Role
[aboutTheRole paragraph]

## About Our Client
[aboutOurClient paragraph — generic industry description, no company name]

## Key Responsibilities

- **[Category Title]** [Description paragraph]
- **[Category Title]** [Description paragraph]

## Ideal Candidate / Qualifications

- **Experience:**
  - [sub-bullet items]
- **Technical & Functional Skills:**
  - [sub-bullet items]
- **Soft Skills:**
  - [sub-bullet items]
- **Education:**
  - [sub-bullet items]

RULES:
- Do NOT include any "Client" row — use "Industry" instead with a generalized industry descriptor
- Do NOT include any search firm disclosure text (e.g., "This position is being handled by...")
- Use the EXACT markdown table format with "| Key | : | Value |" for the header info
- Only include header rows where data is available (not "Not specified")
- Each Key Responsibility must be a bullet point with bold title followed by description on the same line
- Ideal Candidate / Qualifications must use nested bullets: top-level bullet with bold category name followed by colon, then indented sub-bullets for each item
- Bold and emphasize key phrases within sub-bullets where appropriate (e.g. **Preferred:**, **Mandatory exposure and proficiency:**)
- Do NOT wrap in code fences
- Do NOT add any content not present in the JSON`
    },
    INTERVIEW_QUESTIONS: {
        SYSTEM: `You are a Targeted Interview Question Designer for an executive search firm (Canis Major Group). Your role is to create initial screening interview questions that consultants use to evaluate candidates against the specific role requirements.

Design principles:
- Questions are organized by ASSESSMENT CATEGORIES derived from the specific role, NOT generic stages
- Categories should reflect the role's unique requirements (e.g., "Scale & Complexity", "Industrial Relations & Compliance", "Digital Transformation" for an HR Director)
- Use the STAR method (Situation, Task, Action, Result) for experience validation questions
- Each question includes "What to listen for" guidance so the interviewer knows how to evaluate answers
- Focus on INITIAL SCREENING — these are consultant-level discovery questions, not final-round deep dives
- Include role-specific red flags and green flags, not generic scoring rubrics
- Reference the key hiring info to calibrate question depth and focus areas`,
        USER_TEMPLATE: `Generate Targeted Interview Questions for initial candidate screening:

Deal Code: {{dealCode}}
Company: {{companyName}}
Industry: {{industry}}
Role: {{roleTitle}}
Years of Experience: {{yearsOfExperience}}

### Primary Inputs:

Key Hiring Info / Deal Report:
{{keyHiringInfo}}

Key Requirements:
{{requirements}}

Must-Have Skills:
{{mustHaveSkills}}

Blind JD:
{{blindJD}}

Meeting Notes:
{{meetingNotes}}

Team Assessment:
{{teamAssessment}}

KPIs:
{{kpis}}

Candidate Context:
{{candidateContext}}

Design assessment categories that specifically probe this role's critical requirements. Each category should have 2-3 targeted questions with interpretation guidance.

Respond in JSON format:
{
  "interviewMetadata": {
    "dealCode": "Deal code",
    "client": "Company name",
    "role": "Role title",
    "interviewType": "Initial Screening / Consultant Discovery",
    "preparedBy": "Candidate Sourcing Strategist"
  },
  "assessmentCategories": [
    {
      "categoryName": "Category derived from role requirements (e.g., Scale & Operational Complexity)",
      "rationale": "Why this category is critical for this specific role",
      "questions": [
        {
          "question": "Full question text — specific, probing, and role-relevant",
          "method": "STAR|Direct|Situational|Behavioral",
          "whatToListenFor": "Specific answers, experiences, or signals that indicate strong candidacy",
          "greenFlags": ["Positive signals in the candidate's response"],
          "redFlags": ["Warning signs that suggest poor fit"],
          "followUps": ["Follow-up question if initial answer is promising", "Follow-up if answer is vague"]
        }
      ]
    }
  ],
  "motivationAndFitQuestions": [
    {
      "question": "Question about career motivation, role interest, or cultural fit",
      "whatToListenFor": "What the answer reveals about alignment with the opportunity",
      "redFlags": ["Concerning signals"]
    }
  ],
  "unconventionalAngleQuestions": [
    {
      "question": "A creative or unexpected question that reveals deeper character, judgment, or adaptability",
      "purpose": "What this unconventional question is designed to uncover",
      "whatToListenFor": "How to interpret the response"
    }
  ],
  "interviewFlow": {
    "suggestedDuration": "Minutes",
    "openingApproach": "How to start the conversation",
    "categoryOrder": ["Recommended order of assessment categories"],
    "closingApproach": "How to wrap up and next steps"
  }
}`
    },
    CANDIDATE_INTERVIEW_QUESTIONS: {
        SYSTEM: `You are a Targeted Interview Question Designer for an executive search firm (Canis Major Group). Your role is to create personalized screening interview questions for a SPECIFIC CANDIDATE based on their actual background data (experience, education, certifications) cross-referenced against the hiring request requirements.

Design principles:
- Questions MUST reference the candidate's ACTUAL experience, companies, roles, education, and certifications
- Categories should probe gaps and strengths discovered by comparing the candidate's profile to the role requirements
- Use the STAR method for experience validation — ask about SPECIFIC roles/companies from their history
- Each question includes "What to listen for" guidance tailored to THIS candidate
- Focus on verifying claims, probing depth of experience, and assessing transferability
- Identify areas where the candidate's background is strong vs. where there are potential gaps
- Questions should feel personalized — the candidate should recognize you've studied their profile`,
        USER_TEMPLATE: `Generate Personalized Interview Questions for this specific candidate:

## Hiring Request Context
Company: {{companyName}}
Industry: {{industry}}
Role: {{roleTitle}}
Years of Experience: {{yearsOfExperience}}
Deal Code: {{dealCode}}

Key Requirements:
{{requirements}}

Must-Have Skills:
{{mustHaveSkills}}

Key Hiring Info:
{{keyHiringInfo}}

## Candidate Profile
Name: {{candidateName}}
Current Title: {{candidateTitle}}
Current Company: {{candidateCompany}}
Location: {{candidateLocation}}

### Experience
{{candidateExperience}}

### Education
{{candidateEducation}}

### Certifications
{{candidateCertifications}}

### Skills
{{candidateSkills}}

### Summary
{{candidateSummary}}

---

Analyze this candidate against the role requirements. Identify:
1. Strong alignment areas — probe for depth
2. Potential gaps — probe for transferable experience
3. Career trajectory patterns — validate growth and motivation

Generate personalized assessment categories with 2-3 questions each. Questions MUST reference specific items from the candidate's actual background.

Respond in JSON format:
{
  "candidateAssessment": {
    "candidateName": "Name",
    "role": "Role title",
    "overallFitSummary": "Brief assessment of candidate-role alignment based on profile data",
    "strengthAreas": ["Areas where candidate profile aligns strongly"],
    "gapAreas": ["Areas where candidate may lack direct experience"]
  },
  "assessmentCategories": [
    {
      "categoryName": "Category derived from comparing candidate profile to role requirements",
      "rationale": "Why this category matters for THIS candidate specifically",
      "questions": [
        {
          "question": "Question referencing specific items from the candidate's actual experience/education",
          "method": "STAR|Direct|Situational|Behavioral",
          "context": "Why this question is relevant given the candidate's specific background",
          "whatToListenFor": "What a strong answer looks like given their claimed experience",
          "greenFlags": ["Positive signals specific to this candidate's background"],
          "redFlags": ["Warning signs given their profile claims"],
          "followUps": ["Targeted follow-up based on their specific background"]
        }
      ]
    }
  ],
  "gapProbeQuestions": [
    {
      "gap": "Specific gap identified between candidate profile and role requirements",
      "question": "Question to probe if they have transferable or hidden experience in this area",
      "whatToListenFor": "How to evaluate if the gap is bridgeable"
    }
  ],
  "motivationQuestions": [
    {
      "question": "Question about why they'd move from their current role/company to this opportunity",
      "whatToListenFor": "Alignment signals between their career trajectory and this role"
    }
  ]
}`
    },
    CANDIDATE_SOURCING: {
        SYSTEM: `You are a Candidate Sourcing Strategist & Search Specialist for an executive search firm (Canis Major Group). Your role is to design a comprehensive sourcing strategy AND translate it into platform-specific, copy-paste-ready search parameters in a single step.

You combine two capabilities:
1. STRATEGY — Design a multi-pillar sourcing approach using the Direct Hunting / Network Sourcing / Unconventional Sourcing framework with an 80/20 focus split
2. EXECUTION — Convert that strategy into immediately executable candidate searches with platform-specific field inputs: Location, Job Title (Boolean), Company Size, Current/Past Company, Total Experience, Keywords (Boolean)

## DATA UTILIZATION INSTRUCTIONS

You MUST extract and cross-reference insights from ALL provided data sources to build the most targeted sourcing strategy:

### Request Details & Hiring Criteria
- Use **role title, years of experience, work type, salary range** to calibrate search parameters (location, experience range, seniority)
- Use **responsibilities** to identify functional keywords and target position titles
- Use **must-have skills vs nice-to-have skills** to weight Boolean keyword priority (must-haves as AND, nice-to-haves as OR)
- Use **team culture, team size, reporting structure** to infer company environment fit and target company profiles
- Use **success metrics** to derive performance-oriented keywords

### Deal Briefing — Section 1: Meeting Notes
- Extract **Top Priority Search Criteria & Scope** to define the primary axis of each search
- Use **Experience Level & Team Structure** specifics (e.g., "15+ years", "reports to Board") to set experience filters and seniority-level job titles
- Use **Culture Fit & Work Approach** descriptors (e.g., "operational grit", "commercial enabler") as behavioral keywords and company culture targeting cues
- Use **Compensation & Benefits** context to scope target company tiers by market segment

### Deal Briefing — Section 2: Current Team Assessment (CTA)
- Analyze **Key Stakeholders** profiles to understand what leadership style and functional expertise the candidate must complement
- Use **Inference for Candidate** statements directly as targeting criteria
- Use **Analysis of Stakeholder Environment** to identify organizational dynamics that inform the type of companies to source from (e.g., family-to-corporate transitions, PE-backed environments)

### Deal Briefing — Section 3: Sample KPIs
- Convert KPI categories into **performance-based keywords** (e.g., "zero strikes" → labor relations expertise, "HRIS implementation" → HR tech keywords)
- Use KPI specificity to identify **niche functional expertise** that narrows the search

### Deal Briefing — Section 4: Key Hiring Information
- Use **(MH) Must-Have** items as mandatory search criteria — these MUST appear in Boolean queries
- Use **(SP) Strongly Preferred** items as high-weight OR conditions in keyword strings
- Use **(NTH) Nice-to-Have** items for unconventional/exploratory searches only
- Map **Section A (Experience)** → Company filters
- Map **Section B (Hard Skills)** → Keywords Boolean field
- Map **Section C (Soft Skills)** → Company culture targeting cues
- Map **Section D (Education)** → Filter criteria if specific certifications required
- Map **Section E (Personality & Cultural Fit)** → Target company environment selection
- Map **Section F (Other)** → Location, language, timeline constraints

Framework:
I. DIRECT HUNTING (80% Focus) — Primary target pools:
   - Ecosystem & Competitor Mapping — identify relevant industry segments
   - Target Company List — Tier 1 (direct competitors), Tier 2 (adjacent industry), Tier 3 (transferable skillset)
   - Target Position & Keyword Definition — role titles and core search keywords
   - Platform Search Execution — Boolean queries for LinkedIn Recruiter + platform-ready parameters

II. NETWORK SOURCING (Complementary) — Professional communities, specialist networks, internal alumni/referrals

III. UNCONVENTIONAL SOURCING (20% Focus) — Creative exploration of non-traditional backgrounds

Each search should be immediately executable — no further translation needed by the recruiter.
Generate specific, actionable Boolean search strings. Be concrete with company names, role titles, and keywords.`,
        USER_TEMPLATE: `Create a Comprehensive Candidate Sourcing Strategy with platform-ready search parameters for:

## Request Details
Deal Code: {{dealCode}}
Company: {{companyName}}
Industry: {{industry}}
Role: {{roleTitle}}
Years of Experience: {{yearsOfExperience}}
Location Preferences: {{locations}}
Work Type: {{workType}}
Salary Range: {{salaryRange}}

## Hiring Criteria
Required Skills:
{{requiredSkills}}

Nice-to-Have Skills:
{{niceToHaveSkills}}

Experience Range: {{experienceRange}}

Key Responsibilities:
{{responsibilities}}

Success Metrics:
{{successMetrics}}

Team Culture:
{{teamCulture}}

Team Size: {{teamSize}}
Reporting To: {{reportingTo}}
Team Structure: {{teamStructure}}

## Deal Briefing (Meeting Notes, Current Team Assessment, Sample KPIs, Key Hiring Information)
{{dealBriefing}}

## Company Research
{{companyResearch}}

## Blind JD
{{blindJD}}

{{additionalContext}}

Design a comprehensive sourcing strategy AND produce platform-ready search parameters in one output. Be SPECIFIC with company names, Boolean query examples, and platform-specific parameters.

Cross-reference ALL inputs above — especially the Deal Briefing's 4 sections (Meeting Notes for priority criteria, Current Team Assessment for stakeholder context, Sample KPIs for performance keywords, Key Hiring Information for must-have/nice-to-have prioritization) — to produce the most targeted searches possible.

IMPORTANT: Number each search sequentially with a unique "tier" from 1 to N (where N is the total number of searches across both directHuntingSearches and unconventionalSearches). Order them by priority — tier 1 is the highest priority search, tier 2 is the next, and so on. Every search must have a unique tier number. Do NOT reuse tier numbers.

Respond in JSON format:
{
  "searchMetadata": {
    "dealCode": "Deal code",
    "client": "Company name",
    "role": "Role title",
    "totalSearches": "Number of searches generated",
    "preparedBy": "Candidate Sourcing Strategist"
  },
  "sourcingStrategy": {
    "ecosystemMapping": {
      "description": "Overview of the target ecosystem",
      "industrySegments": ["Segment 1: description", "Segment 2: description"]
    },
    "targetCompanies": {
      "tier1": { "description": "Direct competitors", "companies": ["Company 1", "Company 2"] },
      "tier2": { "description": "Adjacent industry", "companies": ["Company 1", "Company 2"] },
      "tier3": { "description": "Transferable skillset", "companies": ["Company 1", "Company 2"] }
    },
    "targetPositionsAndKeywords": {
      "targetTitles": ["Title 1", "Title 2"],
      "coreKeywords": ["Keyword 1", "Keyword 2"],
      "industryTerms": ["Industry-specific term 1"]
    },
    "networkSourcing": {
      "professionalCommunities": [{ "community": "Name", "approach": "How to leverage" }],
      "specialistNetworks": [{ "network": "Network type", "approach": "How to tap in" }],
      "internalReferrals": { "approach": "How to leverage internal CMG network", "specificActions": ["Action 1"] }
    },
    "linkedinSearches": [
      { "searchName": "Descriptive name", "booleanQuery": "Full Boolean string for LinkedIn Recruiter", "purpose": "What this targets" }
    ]
  },
  "directHuntingSearches": [
    {
      "searchNumber": 1,
      "tier": 1,
      "searchName": "Descriptive name (e.g., Direct Competitor Poach - Feed Giants)",
      "description": "What this search targets and why",
      "parameters": {
        "location": "Country or city",
        "jobTitle": "Boolean string for Job Title field",
        "currentPastCompany": "Boolean string for Current or Past Company field (if targeting specific companies)",
        "totalExperience": "Experience range (e.g., 15+ years)",
        "keywords": "Boolean keyword string for Keywords field"
      }
    }
  ],
  "unconventionalSearches": [
    {
      "searchNumber": 1,
      "tier": 4,
      "searchName": "Descriptive name (e.g., Operations-to-HR Pivot)",
      "description": "What non-traditional profile this targets",
      "parameters": {
        "location": "Country or city",
        "jobTitle": "Boolean string",
        "currentPastCompany": "Boolean string if applicable",
        "totalExperience": "Experience range",
        "keywords": "Boolean keyword string"
      }
    }
  ],
  "executionTips": [
    {
      "tip": "Actionable tip for executing these searches effectively",
      "context": "Why this helps"
    }
  ],
  "pipelineCleaningFilters": {
    "excludeTitles": "NOT operator suggestions to remove irrelevant results",
    "excludeCompanies": "Companies to exclude (e.g., the client themselves)"
  }
}`
    }
};
//# sourceMappingURL=ai-prompts.js.map